import { Globe } from "lucide-react";
import { BizminerAdminOrganization } from "@/types/serializers";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

interface Props {
  organization: BizminerAdminOrganization;
}

export default function OrganizationDetails({ organization }: Props) {
  return (
    <Card className="lg:col-span-2">
      <CardHeader className="border-b">
        <CardTitle className="text-lg">Organization Details</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <dt className="text-sm font-medium text-muted-foreground">Name</dt>
            <dd className="mt-1 text-sm text-foreground">
              {organization.name}
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-muted-foreground">Slug</dt>
            <dd className="mt-1 text-sm text-foreground font-mono bg-muted px-2 py-1 rounded">
              {organization.slug}
            </dd>
          </div>
          {organization.website && (
            <div>
              <dt className="text-sm font-medium text-muted-foreground">
                Website
              </dt>
              <dd className="mt-1 text-sm">
                <a
                  href={organization.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:text-primary/80 inline-flex items-center"
                >
                  <Globe className="w-3 h-3 mr-1" />
                  {organization.website}
                </a>
              </dd>
            </div>
          )}
          <div>
            <dt className="text-sm font-medium text-muted-foreground">
              Created
            </dt>
            <dd className="mt-1 text-sm text-foreground">
              {organization.created_at}
            </dd>
          </div>
          {organization.description && (
            <div className="md:col-span-2">
              <dt className="text-sm font-medium text-muted-foreground">
                Description
              </dt>
              <dd className="mt-1 text-sm text-foreground">
                {organization.description}
              </dd>
            </div>
          )}
        </dl>
      </CardContent>
    </Card>
  );
}
